// Use this method to interpolate classNames efficiently.
// You keep the Intellisense and can avoid having `false` or `undefined` in the CSS output

import { PayFitColor } from '../types/module';

/* e.g:
<div className={classNames(
    isDark ? "bg-blue-301" : "bg-blue-21",
    isEncapsulated ? "w-1/2" : "w-full",
    "px-24 py-48"
)}></div>
*/
export type ClassName = string | undefined | boolean | null;

export const classNames = (...c: ClassName[]): string =>
  c.filter((elt: ClassName) => typeof elt === 'string' && elt.trim()).join(' ');

export const applyBackgroundColor = (color: PayFitColor): string => {
  switch (color) {
    case 'blue':
      return 'bg-blue-21';
    case 'azur':
      return 'bg-azur-21';
    case 'coral':
      return 'bg-coral-21';
    case 'mint':
      return 'bg-mint-21';
    case 'purple':
      return 'bg-purple-21';
    case 'yellow':
      return 'bg-yellow-21';
    case 'neutral':
      return 'bg-neutral-21';
    case 'grey':
      return 'bg-lang-31';
    default:
      return 'bg-neutral-1';
  }
};
